import { useCallback } from "react";
import LayersIcon from '@material-ui/icons/Layers';
import Button from "@material-ui/core/Button";
import { layersVisibleState } from "../../store/LayersVisibleState";
import { useRecoilState } from "recoil";

function Layers() {
  const [layersVisible, setLayersVisible] = useRecoilState(layersVisibleState);

  const clickHandler = useCallback(() => {
    setLayersVisible(!layersVisible);
  },[layersVisible, setLayersVisible]);

  return (
    <Button onClick={clickHandler}>
      <div className="header-item">
        <LayersIcon color={layersVisible? 'primary': 'inherit'}/>
        <span className="header-item-label">Layers</span>
      </div>
    </Button>
  );
}

export default Layers;